import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DataForm from "components/UI/form/DataForm";
import { fetchDataAction } from "store/features/coreSlice";
import PropTypes from "prop-types";
import dataVal from "../../dataVal.json";

const FilterForm = ({ setNumber, setUrl, baseUrl }) => {
  const dispatch = useDispatch();
  const { filtercounteries, filtercities, limit } = useSelector((state) => state.core);
  const [data, setData] = useState([]);
  const [filteredValues, setFilteredValues] = useState(null);
  const [countryId, setCountryId] = useState(null);

  const [initialValues, setInitialValues] = useState(dataVal.initialValuesFilter);

  const orgData = () => {
    setData([
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "country_id",
        id: "country_id",
        label: "country_id",
        data: filtercounteries,
        size: 3,
        title: "country",
      },
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "city_id",
        id: "city_id",
        label: "city_id",
        data: filtercities,
        size: 3,
        title: "city",
      },
      {
        type: "TextField",
        name: "title",
        id: "title",
        label: "title",
        size: 3,
        title: "title",
      },
    ]);
  };

  useEffect(() => {
    if (filtercounteries !== undefined && filtercities !== undefined) {
      orgData();
    }
  }, [filtercities, filtercounteries]);

  const generateUrl = (values) => {
    let str = baseUrl;
    const keys = Object.keys(values);
    keys.forEach((element) => {
      if (values[element] && values[element] !== []) {
        if (typeof values[element] === "object") {
          if (element === "country_id") {
            str += `&filter[city_id.${element}.id]=${values[element].id}`;
          } else str += `&filter[${element}.id]=${values[element].id}`;
        } else {
          str += `&filter[${element}][contains]=${values[element]}`;
        }
      }
    });
    return str;
  };

  const setPayload = (values) => {
    setFilteredValues(values);
    setNumber(1);
    if (values) setInitialValues(values);
    setUrl(generateUrl(values));
    dispatch(
      fetchDataAction({
        url: `${generateUrl(values)}&meta=*&limit=${limit}&page=${1}`,
        varName: "libraries",
      })
    );
  };

  const setFieldSelectedValue = (name, values) => {
    if (name === "country_id") {
      setCountryId(values);
      dispatch(
        fetchDataAction({
          url: `items/cities?fields=id,arabic_title&filter[country_id]=${values.id}`,
          varName: "filtercities",
        })
      );
    }
  };

  const onChangeHandler = (name, text) => {
    if (name === "country_id")
      dispatch(
        fetchDataAction({
          url: `items/counteries?fields=id,arabic_title&filter[arabic_title][${
            text ? `contains]=${text}` : "nempty]=true"
          }&limit=${limit}`,
          varName: "filtercounteries",
        })
      );

    if (name === "city_id") {
      let urlVal = `items/cities?fields=id,arabic_title&filter[arabic_title][${
        text ? `contains]=${text}` : "nempty]=true"
      }&limit=${limit}`;
      if (countryId) urlVal += `&filter[country_id]=${countryId.id}`;
      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "filtercities",
        })
      );
    }
  };

  const getData = (dataNeeded) => {
    dataNeeded.forEach((element) => {
      dispatch(
        fetchDataAction({
          url: `items/${element}?fields=id,arabic_title&limit=${limit}`,
          varName: `filter${element}`,
        })
      );
    });
  };

  useEffect(() => {
    getData(dataVal.oterData);
  }, []);

  useEffect(() => {
    setPayload(filteredValues || initialValues);
  }, [limit]);

  if (data.length === 0) {
    return null;
  }

  return (
    <DataForm
      filter
      yupObj={{}}
      name="librariesFilter"
      data={data}
      initialValues={initialValues}
      setPayload={setPayload}
      setFieldSelectedValue={setFieldSelectedValue}
      onChange={onChangeHandler}
    />
  );
};

FilterForm.propTypes = {
  setUrl: PropTypes.func.isRequired,
  setNumber: PropTypes.func.isRequired,
  baseUrl: PropTypes.string.isRequired,
};
export default FilterForm;
